/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import CardNewProfile from '@dtvgo/card-new-profile';
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableCardNewProfile.scss';

export function FocusableCardNewProfile({
  className,
  focused,
  text,
  onMouseDown,
  onMouseEnter,
}) {
  return (
    <InteractiveElement
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      className={
      `dtv-html5-c-card-profile ${
        focused ? 'dtv-html5-c-card-new-profile--focused' : ''
      } ${className}`
    }
    >
      <CardNewProfile text={text} className="dtv-html5-c-card-new-profile--logo" />
    </InteractiveElement>
  );
}

FocusableCardNewProfile.propTypes = {
  className: PropTypes.string,
  focused: PropTypes.bool,
  text: PropTypes.shape({}),
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

FocusableCardNewProfile.defaultProps = {
  className: '',
  focused: false,
  text: {},
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

export default memo(withInteractiveFocusable()(memo(FocusableCardNewProfile)));
